import React from 'react';
import ListItem from 'jd-library/ListItem';
import Image, { AddVideoDiv } from '../../common/product-image/ImageViewUpload';

const SingleSortItem = React.forwardRef((props,ref) => {
	const {
		item,
		index
	} = props;

	return(
		<div className='card-container' ref={ref}>
            <ListItem
                className={'card-holder'}
                leftSection={
                    <div className="add-on-image">
                        <i className="icon-SortMenu" />
                    </div>
                }
                middleSection={
                    <div>
                        <div className="single-item-container">
                            <Image
                                imageUrl={item.imgURL || ''}
                                baseURL={item.base64Url || ''}
                                isReadOnly={true}
                            />
                            {index == 0 ?
                                <div
                                    className={'default-title'}
                                >
                                    <span><i className={`primary-icon icon-starFill`}></i>PRIMARY</span>
                                </div>
                                : null
                            }
                        </div>

                    </div>
                }
                rightSection={''}
            />
		</div>
	)
})


export default SingleSortItem;
